if (!customElements.get('product-reviews')) {
  class ProductReviews extends HTMLElement {
    constructor() {
      super();

      const starSvg = `<svg class="icon icon--star w-full" viewBox="0 0 16 16" fill="none">
      <path d="M11.8378 15.3828C12.0526 15.5 12.2773 15.5293 12.5116 15.4707C12.746 15.4121 12.9267 15.2802 13.0536 15.0752C13.1806 14.8701 13.2245 14.6504 13.1855 14.416V14.416L12.453 10.1387L15.5585 7.12108C15.7343 6.9453 15.827 6.74022 15.8368 6.50585C15.8466 6.27147 15.7782 6.05663 15.6317 5.86132C15.4852 5.666 15.2851 5.54882 15.0311 5.50975V5.50975L10.7538 4.89452L8.84952 1.02734C8.73234 0.792968 8.56144 0.636719 8.33683 0.558594C8.11222 0.480469 7.88761 0.480469 7.663 0.558594C7.4384 0.636719 7.2675 0.792968 7.15031 1.02734V1.02734L5.24602 4.89452L0.968687 5.50975C0.714781 5.54882 0.514586 5.666 0.368102 5.86132C0.221618 6.05663 0.153259 6.27147 0.163025 6.50585C0.17279 6.74022 0.265564 6.9453 0.441344 7.12108V7.12108L3.5468 10.1387L2.81439 14.416C2.77532 14.6504 2.81927 14.8701 2.94622 15.0752C3.07317 15.2802 3.25384 15.4121 3.48821 15.4707C3.72259 15.5293 3.94719 15.5 4.16204 15.3828V15.3828L7.99992 13.3906L11.8378 15.3828Z" fill="#271919"/>
      </svg>
      `;
      const halfStarSvg = `<svg class="icon icon--star w-full" viewBox="0 0 16 16" fill="none">
      <path opacity="0.3" d="M11.6757 14.8828C11.8905 15 12.1151 15.0293 12.3495 14.9707C12.5839 14.9121 12.7646 14.7802 12.8915 14.5752C13.0185 14.3701 13.0624 14.1504 13.0233 13.916V13.916L12.2909 9.63865L15.3964 6.62108C15.5722 6.4453 15.6649 6.24022 15.6747 6.00585C15.6845 5.77147 15.6161 5.55663 15.4696 5.36132C15.3231 5.166 15.1229 5.04882 14.869 5.00975V5.00975L10.5917 4.39452L8.68742 0.527343C8.57023 0.292968 8.39933 0.136719 8.17472 0.0585937C7.95011 -0.0195312 7.7255 -0.0195312 7.5009 0.0585937C7.27629 0.136719 7.10539 0.292968 6.9882 0.527343V0.527343L5.08391 4.39452L0.806577 5.00975C0.552672 5.04882 0.352477 5.166 0.205993 5.36132C0.0595091 5.55663 -0.00884995 5.77147 0.0009155 6.00585C0.010681 6.24022 0.103454 6.4453 0.279235 6.62108V6.62108L3.3847 9.63865L2.65228 13.916C2.61321 14.1504 2.65716 14.3701 2.78411 14.5752C2.91106 14.7802 3.09173 14.9121 3.3261 14.9707C3.56048 15.0293 3.78509 15 3.99993 14.8828V14.8828L7.83781 12.8906L11.6757 14.8828Z" fill="#271919" fill-opacity="0.3"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M7.83854 2.77811e-07C7.72599 -8.49642e-05 7.61344 0.0194462 7.5009 0.0585937C7.27629 0.136719 7.10539 0.292968 6.9882 0.527343L5.08391 4.39452L0.806577 5.00975C0.552672 5.04882 0.352477 5.166 0.205993 5.36132C0.0595091 5.55663 -0.00884995 5.77147 0.000915501 6.00584C0.010681 6.24022 0.103454 6.4453 0.279235 6.62108L3.3847 9.63865L2.65228 13.916C2.61321 14.1504 2.65716 14.3701 2.78411 14.5752C2.91106 14.7802 3.09173 14.9121 3.3261 14.9707C3.56048 15.0293 3.78509 15 3.99993 14.8828L7.83781 12.8906L7.83854 12.891V2.77811e-07Z" fill="#271919"/>
      </svg>`;

      this.starElement = `<span class="star w-3">${starSvg}</span>`;
      this.starElementHalf = `<span class="star w-3">${halfStarSvg}</span>`;

      this.apiKey = window.trustpilot.api_key;
      this.buid = window.trustpilot.business_unit_id;

      this.starsContainer = this;
      this.skuParameter = '';

      this.sku = this.dataset.productSku;
      if (this.sku) {
        this.skuParameter = `&sku=${this.sku}`;
      }
      this.fetchProductData();
    }

    fetchGeneralData() {
      fetch(
        // Put the name and the key to the settings?
        `https://api.trustpilot.com/v1/business-units/${this.buid}?apikey=${this.apiKey}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.totalGeneralScore = data.score.trustScore;
          const isInteger = Number.isInteger(this.totalGeneralScore);

          if (this.starsContainer) {
            this.renderStars(isInteger, this.totalGeneralScore, this.starsContainer, true);
          }
        });
    }

    fetchProductData() {
      fetch(
        `https://api.trustpilot.com/v1/product-reviews/business-units/${this.buid}?apikey=${this.apiKey}&sku=${this.skuParameter}`
      )
        .then((response) => response.json())
        .then((data) => {
          this.totalScore = data.starsAverage;
          const isInteger = Number.isInteger(this.totalScore);

          if (this.totalScore === 0) {
            return;
          }

          if (this.starsContainer) {
            this.renderStars(isInteger, this.totalScore, this.starsContainer, true);
          }
        });
    }

    renderStars(isInteger, starsNumber, container, needsTotal) {
      const windowWidth = window.innerWidth;
      if (needsTotal) {
        if (this.totalScore === 0) {
          container.innerHTML = `<span class="pt-[0.063rem]">${this.totalGeneralScore}</span>`;
        } else {
          container.innerHTML = `<span class="pt-[0.063rem]">${this.totalScore}</span>`;
        }
      }

      if (windowWidth > 480) {
        for (let i = 0; i < Math.trunc(starsNumber); i++) {
          container.innerHTML += this.starElement;
        }
        if (!isInteger) {
          container.innerHTML += this.starElementHalf;
        }
      } else {
        container.innerHTML += this.starElement;
      }
    }
  }
  window.ProductReviews = ProductReviews;

  customElements.define('product-reviews', ProductReviews);
}

// Render the amount of product reviews
if (!customElements.get('product-amount')) {
  class ProductAmount extends HTMLElement {
    constructor() {
      super();

      this.apiKey = window.trustpilot.api_key;
      this.buid = window.trustpilot.business_unit_id;

      this.skuParameter = '';

      this.sku = this.dataset.productSku;
      if (this.sku) {
        this.skuParameter = `&sku=${this.sku}`;
      }
      this.fetchProductAmount();
    }

    fetchProductAmount() {
      fetch(
        `https://api.trustpilot.com/v1/product-reviews/business-units/${this.buid}?apikey=${this.apiKey}&sku=${this.skuParameter}`
      )
        .then((response) => response.json())
        .then((data) => {
          const totalAmount = data.numberOfReviews.total;

          if (this.totalAmount === 0) {
            return;
          }

          const reviewAmount = document.querySelector('.product-media__reviews-amount');
          const container = document.querySelector('.product-media__reviews-container');

          if (reviewAmount && totalAmount != 0) {
            reviewAmount.innerHTML = `(${totalAmount})`;
            container.style.display = 'flex';
          } else {
            container.style.display = 'none';
          }
        });
    }
  }
  window.ProductAmount = ProductAmount;

  customElements.define('product-amount', ProductAmount);
}
